export default __webpack_public_path__ + "static/media/armada.b04f8521.png";